import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    padding: 0 ", ";\n    margin: 0 ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    padding: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    background-color: ", ";\n    color: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components'; // TODO: add optional contrast attribute to typography elements
// body

export var BodyJumbo = styled.span(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.bodyJumbo.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.bodyJumbo.fontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.bodyJumbo.lineHeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.bodyJumbo.fontWeight;
});
export var Body = styled.span(_templateObject2(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.body.fontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.body.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.body.lineHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.body.fontWeight;
});
export var BodyBig = styled.span(_templateObject3(), function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.bodyBig.fontFamily;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.bodyBig.fontSize;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.bodyBig.lineHeight;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.bodyBig.fontWeight;
});
export var BodyBold = styled.span(_templateObject4(), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.bodyBold.fontFamily;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.typography.bodyBold.fontSize;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.bodyBold.lineHeight;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.bodyBold.fontWeight;
});
export var BodySmall = styled.span(_templateObject5(), function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.bodySmall.fontFamily;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typography.bodySmall.fontSize;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.bodySmall.lineHeight;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.typography.bodySmall.fontWeight;
});
export var BodySmallBold = styled.span(_templateObject6(), function (_ref21) {
  var theme = _ref21.theme;
  return theme.typography.bodySmallBold.fontFamily;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.typography.bodySmallBold.fontSize;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.typography.bodySmallBold.lineHeight;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.typography.bodySmallBold.fontWeight;
});
export var BodyMicro = styled.span(_templateObject7(), function (_ref25) {
  var theme = _ref25.theme;
  return theme.typography.bodyMicro.fontFamily;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyMicro.fontSize;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.typography.bodyMicro.lineHeight;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.typography.bodyMicro.fontWeight;
});
export var Notification = styled.span(_templateObject8(), function (_ref29) {
  var theme = _ref29.theme;
  return theme.typography.notification.fontFamily;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.notification.fontSize;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.typography.notification.lineHeight;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.typography.notification.fontWeight;
});
export var NotificationBold = styled.span(_templateObject9(), function (_ref33) {
  var theme = _ref33.theme;
  return theme.typography.notificationBold.fontFamily;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.typography.notificationBold.fontSize;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.typography.notificationBold.lineHeight;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.typography.notificationBold.fontWeight;
}); // attribution

export var Quote = styled.span(_templateObject10(), function (_ref37) {
  var theme = _ref37.theme;
  return theme.typography.quote.fontFamily;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.typography.quote.fontSize;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.typography.quote.lineHeight;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.typography.quote.fontWeight;
});
export var Author = styled.span(_templateObject11(), function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.author.fontFamily;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.author.fontSize;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.author.lineHeight;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.author.fontWeight;
});

var baseCodeStyles = function baseCodeStyles() {
  return css(_templateObject12(), function (_ref45) {
    var theme = _ref45.theme;
    return theme.typography.code.fontFamily;
  }, function (_ref46) {
    var theme = _ref46.theme;
    return theme.typography.code.fontSize;
  }, function (_ref47) {
    var theme = _ref47.theme;
    return theme.typography.code.lineHeight;
  }, function (_ref48) {
    var theme = _ref48.theme;
    return theme.typography.code.fontWeight;
  }, function (_ref49) {
    var theme = _ref49.theme,
        variant = _ref49.variant;
    return variant === 'dark' ? theme.typography.code.contrastBackgroundColor : 'transparent';
  }, function (_ref50) {
    var theme = _ref50.theme,
        variant = _ref50.variant;
    return variant === 'dark' ? theme.typography.code.contrastColor : 'auto';
  });
}; // code


export var Code = styled.pre(_templateObject13(), baseCodeStyles, function (_ref51) {
  var theme = _ref51.theme;
  return theme.typography.code.padding;
}); // inline code

export var InlineCode = styled.code(_templateObject14(), baseCodeStyles, function (_ref52) {
  var theme = _ref52.theme;
  return theme.spacing.xxs;
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.spacing.xxs;
});